// extracted by mini-css-extract-plugin
export default {"leftBoxWrapper":"LeftBox_leftBoxWrapper__Kf1go","loadingText":"LeftBox_loadingText__rXRsA","dropdown_menu_wrapper":"LeftBox_dropdown_menu_wrapper__R0j-h"};